//
import { RFormFields } from '@/components/reusable_components/next'

/**
 * SlSaleInvoice Fields
 */
export default RFormFields
  .from([
    {
      name: 'id',
      type: 'text-field',
      props: {
        label: 'Folio',
      },
    },
    {
      name: 'sl_customer_business_name',
      type: 'text-field',
      props: {
        label: 'Cliente',
      },
    },
    {
      name: 'emission_date',
      type: 'date-field',
      props: {
        label: 'Emision',
      },
    },
    {
      name: 'g_state_name',
      type: 'text-field',
      props: {
        label: 'Estado',
      },
    },
    {
      name: 'sl_detail_sale_invoices',
      type: 'table-field',
      flex: {
        xs12: true,
      },
      props: {
        headers: [
          {
            text: '#',
            value: 'wh_product_internal_code',
          },
          {
            text: 'nombre',
            value: 'wh_product_name',
          },
          {
            text: 'cantidad',
            value: 'quantity',
            align: 'right',
            format: 'number',
          },
          {
            text: 'precio neto',
            value: 'net_price',
            align: 'right',
            format: 'currency',
          },
          {
            text: 'subtotal',
            value: 'subtotal',
            align: 'right',
            format: 'currency',
          },
        ],
        toolbarTitle: 'Lista de productos incluidos en la factura',
      },
    },
    {
      name: 'net_total',
      type: 'currency-field',
      props: {
        label: 'Neto',
      },
    },
    {
      name: 'iva',
      type: 'currency-field',
      props: {
        label: 'IVA',
      },
    },
    {
      name: 'total',
      type: 'currency-field',
      props: {
        label: 'Total',
      },
    },
  ])